import {
  InventoryApi,
  InventoryTarget,
  InventoryTargetResponse,
  MpxResponseBaseSingle,
} from '@cibo/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { INVENTORIES_QUERY_KEYS } from './queryKeys'

export const useSetInventoryTargets = (inventoryId?: string) => {
  const queryClient = useQueryClient()

  return useMutation<any, AxiosError, InventoryTarget>(
    (data: InventoryTarget) => {
      if (!inventoryId) return Promise.resolve()
      return InventoryApi.setInventoryTargets(inventoryId, data)
    },
    {
      onSuccess: (response: AxiosResponse<MpxResponseBaseSingle<InventoryTargetResponse>>) => {
        queryClient.setQueryData([INVENTORIES_QUERY_KEYS.TARGET, inventoryId], response.data.item)
      },
    }
  )
}
